module.exports = __webpack_public_path__ + "static/img/commonpay.9e7d4fde.png";